var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(" Oops! Something is wrong. "),_c('br')]),_c('p',[_c('a',{attrs:{"href":"/"}},[_vm._v("Go back to homepage.")])])])
}]

export { render, staticRenderFns }